<template>
  <div id="investor_556">
    <div style="display: flex; align-items: center; margin-top: 16px">
      <CCascader
        @CCascader_select_node="fnCCascader_select_val_chart3"
        :default="da_lei_default_value"
        :checkStrictly="true"
        :multiple="true"
        :collapsetags="true"
        :options="category_cascader_options"
        >选择类别
      </CCascader>
      <CCascader
        style="margin-left: 16px"
        :checkStrictly="false"
        :multiple="true"
        :isDelete="false"
        :default="reit_code_default"
        placeholder="请选择个股"
        :collapsetags="true"
        @CCascader_select_val="fnSelect_select_val_chart1_codename"
        :options="CODENAMEDATA">
        选择对比REITs
      </CCascader>
      <div style="display: flex; margin-left: 16px; margin-top: 4px; align-items: center">
        <el-radio v-model="s_radio" label="整体">整体</el-radio>
        <el-radio v-model="s_radio" label="机构类型细分">机构类型细分</el-radio>
      </div>
      <CSelect
        v-if="s_radio === '机构类型细分'"
        style="margin-left: 16px"
        @CSelect_select_val="fnCSelect_chart1"
        :multiple="false"
        :clearable="false"
        auto
        v-bind.sync="select1"
        >选择资金类型</CSelect
      >
      <span class="oneyear" v-if="s_radio === '机构类型细分'">
        <el-checkbox v-model="get_real_holder"></el-checkbox>
        持有者穿透
      </span>
      <el-tooltip
        class="item"
        effect="dark"
        content=""
        placement="top"
        v-if="s_radio === '机构类型细分'">
        <div slot="content">
          持有者穿透说明
          <br />
          【指标定义】
          <br />
          根据在CREITS财报中披露的持有人的名字进行一定程度真实持有人的穿
          <br />
          透，但本系统仅可根据公开信息进行穿透，无法对于集合计划/产品中的
          <br />
          每个投资人穿透，只能根据公开信息一定程度局部穿透;其中理财子较
          <br />
          难以穿透，主要由于目前托管行及理财子较难分辨，因此该部分可能存
          <br />
          在错误，请各位投资人谨慎使用;
          <br />
          <br />
          【计算及示例】
          <br />
          举例1:光大证券资管-光大银行-光证资管诚享6号集合资产管理计划,
          <br />
          上述情况中根据部分公开资料了解，光大银行属于真实的持有人，光大
          <br />
          证券资管为受托机构，因此:
          <br />
          选择穿透:持有人-光大银行，类别-银行/银行理财子
          <br />
          不选择穿透:持有人-光大证券资管，类别-券商资管
          <br />
          <br />
          举例2:华金证券-东吴人寿保险股份有限公司-华金证券东吴人寿15号基
          <br />
          础设施基金策略FOF单-资产管理计划
          <br />
          选择穿透:持有人-东吴人寿保险股份有限公司，类别-保险;
          <br />
          不选择穿透:持有人-华金证券，类别-券商资管
        </div>
        <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
      </el-tooltip>
      <div style="margin-left: auto; margin-right: 0">
        <Download
          key="c_5424"
          v-if="s_radio === '整体'"
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info1"
          :echartRefName="echartRefName4" />
        <Download
          key="c_54241701"
          v-if="s_radio === '机构类型细分'"
          :dButtonsDownloads="dButtonsDownloads"
          :excel_info="excel_info1"
          :echartRefName="echartRefName5" />
      </div>
    </div>
    <div style="margin-top: 16px" v-if="s_radio === '机构类型细分'">
      <CButtons
        style="margin-left: 0"
        :dButtons1="select_2"
        :dButtons1_current="select_2_default"
        @Cbtns_sep="select2Change" />
    </div>
    <div class="chart-title">
      {{
        category_cascader_val_chart3.length === 1 ? category_cascader_val_chart3[0] : '公募REITs'
      }}不同时间段{{ s_radio }}投资人机构占比
    </div>
    <P11 ref="P11Ref" v-if="s_radio === '整体'" :chart_data="chart_data" :loading="loading" />
    <P12
      ref="P12Ref"
      v-if="s_radio === '机构类型细分'"
      :chart_data="chart_data"
      :loading="loading"
      :relative="{ 份额: 3, 亿元: 2, 绝对: 0, 相对: 1 }[this.select_2_default]" />
  </div>
</template>

<script>
import P11 from './P1-1.vue';
import P12 from './P1-2.vue';

import CCascader from '@/components/Basic/CCascader';
import CSelect from '@/components/Basic/CSelect';
import CButtons from '@/components/Basic/CButtons_separate.vue';
import Download from '@/components/Basic/Download.vue';

import { categroyDefaultValue, codesToNameMap2, debounce } from '@/utils';

export default {
  components: { CCascader, CSelect, CButtons, Download, P11, P12 },
  data() {
    const CATEGORYDATA = JSON.parse(localStorage.getItem('FINALLYCATEGORY')) || [];
    // const da_lei_default_value = categroyDefaultValue(CATEGORYDATA);
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    return {
      loading: true,
      echartRefName4: () => ({
        el: document.querySelector('#investor_556 #c_5424'),
        id: 'c_5424',
      }),
      echartRefName5: () => ({
        el: document.querySelector('#investor_556 #c_54241701'),
        id: 'c_54241701',
      }),
      excel_info1: Object.freeze({
        overviewName: '',
        excel_data: [],
        json_fields: {},
      }),
      dButtonsDownloads: Object.freeze([
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ]),
      da_lei_default_value: ['公募REITs'],
      category_cascader_val_chart3: ['公募REITs'],
      category_cascader_options: Object.freeze(CATEGORYDATA),
      reit_code_default: [],
      CODENAMEDATA: Object.freeze(REITsNAME),
      reit_code: [],
      s_radio: '整体',
      select_2: Object.freeze(['亿元', '份额', '绝对', '相对']),
      select_2_default: '亿元',
      select1: {
        default: 'all',
        options: [
          {
            label: '流通及非流通',
            value: 'all',
          },
          {
            label: '流通',
            value: 'float',
          },
          {
            label: '非流通',
            value: 'res',
          },
        ],
      },
      chart_data: [],
      get_real_holder: false,
    };
  },
  computed: {
    queryStr() {
      const r_type = this.category_cascader_val_chart3.join('&r_type=');
      const codes = this.reit_code.join('&codes=');
      const res_type = this.select1.default;
      const relative = { 份额: 3, 亿元: 2, 绝对: 0, 相对: 1 }[this.select_2_default];
      const get_real_holder = this.get_real_holder ? 1 : 0;
      if (this.s_radio === '整体') {
        return `r_type=${r_type || ''}&codes=${codes || ''}`;
      } else {
        return `r_type=${r_type || ''}&codes=${
          codes || ''
        }&res_type=${res_type}&relative=${relative}&get_real_holder=${get_real_holder}`;
      }
    },
  },
  watch: {
    queryStr() {
      this.loading = true;
      this.debounceLoadingData();
    },
    s_radio() {
      this.chart_data = [];
    },
  },
  methods: {
    debounceLoadingData: debounce(function () {
      this.loadingData();
    }, 800),
    select2Change(v) {
      this.select_2_default = v;
    },

    fnCCascader_select_val_chart3(val) {
      if (!val.length) {
        this.$message.error('请选择类别');
        return;
      }
      this.category_cascader_val_chart3 = val;
    },
    fnSelect_select_val_chart1_codename(val) {
      val = val.filter((node) => {
        return node.includes('.');
      });

      this.reit_code = Object.freeze(val);
    },
    fnCSelect_chart1(v) {
      this.select1 = {
        ...this.select1,
        default: v,
      };
    },
    async loadingData() {
      if (this.s_radio === '整体') {
        const { data } = await this.$https.get(
          `/api/v2_chopart/fin_total_holder_proportion?${this.queryStr}`
        );
        setTimeout(() => {
          this.loading = false;
        }, 300);
        if (data.code !== 200) return this.$message.error(data.msg);
        this.chart_data = Object.freeze(data.data);
      } else {
        const { data } = await this.$https.get(
          `/api/v2_chopart/fin_org_holder_detail_proportion?${this.queryStr}`
        );
        setTimeout(() => {
          this.loading = false;
        }, 300);
        if (data.code !== 200) return this.$message.error(data.msg);
        this.chart_data = Object.freeze(data.data);
      }
      if (!this.chart_data.length) return;
      const n = this.category_cascader_val_chart3;
      const json_fields = Object.keys(this.chart_data[0]).reduce((p, c) => {
        p[c] = c;
        return p;
      }, {});
      this.excel_info1 = this.excel_info2 = Object.freeze({
        excel_data: this.chart_data,
        overviewName: `${n.length === 1 ? n[0] : '公募REITs'}不同时间段${
          this.s_radio
        }投资人机构占比`,
        json_fields,
      });
    },
    resize() {
      if (this.s_radio === '整体') {
        setTimeout(() => {
          this.$refs.P11Ref.resize();
        }, 0);
      } else {
        this.$refs.P12Ref.resize();
      }
    },
  },
  mounted() {
    this.loadingData();
    /*    this.reit_code = Object.freeze(
      this.reit_code_default
        .map((item) => {
          return item.find((n) => n.indexOf('.') >= 0);
        })
        .filter((item) => item)
    ); */
  },
};
</script>

<style scoped lang="less">
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: var(--chart_title);
}
/deep/.el-radio__label {
  color: var(--chart_title);
  font-weight: 400;
}

/deep/.el-radio {
  margin-right: 16px;
}

.chart-title {
  margin-top: 16px;
  color: var(--chart_title);
  font-weight: 700;
  font-size: 16px;
  text-align: center;
}
</style>
